'use client';

import { useState, useCallback } from 'react';
import { ChatListPanel } from './chat-list-panel';
import { ChatInterface } from './chat-interface';
import { useCreateConversation } from '@/hooks/use-conversations';

interface ChatsPanelProps {
  projectId: string;
  projectName?: string;
}

export function ChatsPanel({ projectId, projectName = 'Project' }: ChatsPanelProps) {
  const [activeConversationId, setActiveConversationId] = useState<string | null>(null);
  const createConversation = useCreateConversation(projectId);

  const handleChatSelect = useCallback((chatId: string | null) => {
    setActiveConversationId(chatId);
  }, []);

  const handleNewChat = useCallback(async () => {
    // When New Chat is clicked, clear the active conversation to show welcome screen
    setActiveConversationId(null);
  }, []);

  const handleStartConversation = useCallback(async (initialMessage: string) => {
    try {
      const conversation = await createConversation.mutateAsync({
        title: initialMessage.slice(0, 50) + (initialMessage.length > 50 ? '...' : ''),
        initialMessage,
      });
      setActiveConversationId(conversation.id);
      return conversation.id;
    } catch (error) {
      console.error('Failed to start conversation:', error);
      return null;
    }
  }, [createConversation]);

  return (
    <div className="flex-1 flex overflow-hidden">
      {/* Chat List Panel - 320px */}
      <ChatListPanel
        projectId={projectId}
        activeChat={activeConversationId || undefined}
        onChatSelect={handleChatSelect}
        onNewChat={handleNewChat}
      />

      {/* Chat Interface - fills remaining width */}
      <ChatInterface
        projectId={projectId}
        projectName={projectName}
        conversationId={activeConversationId}
        onStartConversation={handleStartConversation}
      />
    </div>
  );
}

